const flagAircraft = (color) => {
    return `data:image/svg+xml;utf-8, \
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.22 34.2" height="50px" width="50px"><defs><style>.d{fill:${color};}</style></defs><g id="a"/><g id="b"><g id="c"><g><path class="d" d="M4.22,1.7H28.31c1.05,0,1.91,.85,1.91,1.91V20.79c0,1.05-.85,1.91-1.91,1.91H4.22V1.7h0Z"/><path class="d" d="M3.24,31.22h0V1.59c0-.88-.73-1.59-1.62-1.59S0,.71,0,1.59V31.45H0l1.25,2.51c.15,.31,.59,.31,.75,0l1.25-2.51v-.23Z"/></g></g></g></svg>`
}

export default flagAircraft

